@if (kratosForm) {
  <div class="vops-kratos-form">
    <form [formGroup]="kratosForm" (ngSubmit)="submit()">
      <!-- Flow nodes -->
      @for (node of getVisibleNodes(uiNodes); track node) {
        <div class="vops-kratos-form-input-row">
          <!-- Input fields-->
          <ng-container *ngTemplateOutlet="inputNode; context: { node: node }">
          </ng-container>
          <!-- Messages (e.g. error)-->
          @if (node.messages.length > 0) {
            <ng-container
              *ngTemplateOutlet="messages; context: { messages: node.messages }">
            </ng-container>
          }
        </div>
      }
      <!-- Form Messages -->
      @if (formMessages.length > 0) {
        <div class="mt-2 vops-kratos-form-messages">
          <ng-container
            *ngTemplateOutlet="messages; context: { messages: formMessages }">
          </ng-container>
        </div>
      }
      <!-- Other Buttons -->
      @for (
        node of filterUINodes({
        nodes: uiNodes,
        withoutDefaultAttributes: true,
        groups: groups(),
        attributes: 'button'
        })
        ; track
        node) {
        <v-button
          [fullWidth]="true"
          size="large"
          [label]="getUiNodeLabel(node) | transloco"
          [loading]="loading()"
          [testId]="getTestId(node)"
        (press)="onBtnClick(node)"></v-button>
      }
      <!-- Submit Button -->
      @for (
        node of filterUINodes({
        nodes: uiNodes,
        withoutDefaultAttributes: true,
        groups: excludeGroups(groups(), ['oidc']),
        attributes: 'submit'
        })
        ; track
        node) {
        <v-button
          [fullWidth]="true"
          [label]="getUiNodeLabel(node) | transloco"
          type="submit"
          size="large"
          [disabled]="!kratosForm.valid"
          [loading]="loading()"
          [testId]="getTestId(node)"
        class="w-full"></v-button>
      }
      <!-- SSO -->
      @if (showOIDCGroups()) {
        <div class="flex flex-wrap justify-between gap-3">
          @for (
            node of filterUINodes({
            nodes: uiNodes,
            withoutDefaultAttributes: true,
            groups: ['oidc'],
            attributes: 'submit'
            })
            ; track
            node) {
            @if (getOIDCProvider(node) === 'google') {
              <div class="flex-1">
                <v-sso-button
                  provider="google"
                  [fullWidth]="true"
                (press)="onBtnClick(node)"></v-sso-button>
              </div>
            }
            @if (getOIDCProvider(node) === 'github') {
              <div class="flex-1">
                <v-sso-button
                  provider="github"
                  [fullWidth]="true"
                (press)="onBtnClick(node)"></v-sso-button>
              </div>
            }
            @if (getOIDCProvider(node) === 'microsoft') {
              <div class="flex-1">
                <v-sso-button
                  provider="microsoft"
                  [fullWidth]="true"
                (press)="onBtnClick(node)"></v-sso-button>
              </div>
            }
          }
        </div>
      }
    </form>
  </div>
}

<ng-template #messages let-messages="messages">
  @if (messages.length > 0) {
    <div
      class="vops-kratos-messages"
    [ngClass]="{
      'kratos-info-message': messages[0].type === 'info',
      'kratos-error-message': messages[0].type === 'error'
    }">
      <ul>
        @for (message of messages; track message) {
          <li>
            {{ message.text }}
          </li>
        }
      </ul>
    </div>
  }
</ng-template>

<ng-template #inputNode let-node="node">
  <!-- Default input node -->
  @if (isInputNode(node)) {
    <ng-container [formGroup]="kratosForm!">
      <!--<label [htmlFor]="node.attributes.name">
      {{ getUiNodeLabel(node) | transloco }}
    </label>-->
    <v-input-field
      [label]="getUiNodeLabel(node) | transloco"
      [fControlName]="node.attributes.name">
      <v-input
        [type]="node.attributes.type"
        [placeholder]="getUiNodeLabel(node) | transloco"
        [testId]="testIdPrefix() + node.attributes.name"
      [fControlName]="node.attributes.name"></v-input>
    </v-input-field>
    <!--<input
    [placeholder]="getUiNodeLabel(node) | transloco"
    [id]="node.attributes.name"
    [type]="node.attributes.type"
    [name]="node.attributes.name"
    [formControlName]="node.attributes.name"
    [autocomplete]="node.attributes.autocomplete"
    [required]="node.attributes.required"
    />!-->
  </ng-container>
}

@if (isImageNode(node)) {
  <label [htmlFor]="node.attributes.name">
    {{ getUiNodeLabel(node) | transloco }}
  </label>
  <img
    [src]="node.attributes.src"
    [width]="node.attributes.width"
    [height]="node.attributes.height"
    alt="" />
}

@if (isTextNode(node)) {
  <label [htmlFor]="node.attributes.name">
    {{ getUiNodeLabel(node) | transloco }}
  </label>
  <span class="font-bold">{{ node.attributes.text.text }}</span>
}
</ng-template>
